import React from 'react';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
}

const Logo: React.FC<LogoProps> = ({ size = 'md', showText = true }) => {
  const markSize = size === 'sm' ? 'w-7 h-7' : size === 'lg' ? 'w-10 h-10' : 'w-8 h-8';
  const textSize = size === 'sm' ? 'text-lg' : size === 'lg' ? 'text-2xl' : 'text-xl';

  return (
    <div className="flex items-center gap-2">
      <div className={`${markSize} bg-nova-sky rounded-lg flex items-center justify-center flex-shrink-0`}>
        <svg viewBox="0 0 16 16" className="w-4 h-4" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round">
          <polyline points="2,12 6,7 10,9 14,4" />
          <circle cx="14" cy="4" r="1.5" fill="white" stroke="none" />
        </svg>
      </div>
      {showText && (
        <span className={`font-display font-extrabold text-nova-text tracking-tight ${textSize}`}>
          OnTheWeb
        </span>
      )}
    </div>
  );
};

export default Logo;
